import CareersPage from "./careers.page"
export default CareersPage;
